// Evenimente de conversie — trimit la GA4 (gtag) și Meta Pixel (fbq) DOAR dacă
// sunt încărcate (adică după acceptul de cookies — vezi AnalyticsLoader). Sigure:
// nu aruncă niciodată dacă tracking-ul nu e activ.
export function track(gaName, gaParams, fbName, fbParams) {
  try {
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("event", gaName, gaParams || {});
    }
  } catch (e) { /* noop */ }
  try {
    if (typeof window !== "undefined" && typeof window.fbq === "function") {
      window.fbq("track", fbName || gaName, fbParams || {});
    }
  } catch (e) { /* noop */ }
}

const num = (v) => (Number.isFinite(Number(v)) ? Number(v) : 0);

// Achiziție finalizată (checkout reușit).
export const trackPurchase = (value, currency, itemName) =>
  track(
    "purchase",
    { value: num(value), currency: currency || "RON", items: itemName ? [{ item_name: itemName }] : undefined },
    "Purchase",
    { value: num(value), currency: currency || "RON", content_name: itemName || undefined }
  );

// Început de checkout (funnel).
export const trackBeginCheckout = (value, currency, itemName) =>
  track(
    "begin_checkout",
    { value: num(value), currency: currency || "RON", items: itemName ? [{ item_name: itemName }] : undefined },
    "InitiateCheckout",
    { value: num(value), currency: currency || "RON", content_name: itemName || undefined }
  );

// Lead — formular de contact / cerere de programare.
export const trackLead = (source) =>
  track("generate_lead", { source: source || "" }, "Lead", { content_name: source || "" });

// Abonare newsletter.
export const trackSignup = (method) =>
  track("sign_up", { method: method || "newsletter" }, "CompleteRegistration", { content_name: "newsletter" });

// Vizualizare produs (pagina unui curs).
export const trackViewItem = (itemName, value, currency) =>
  track(
    "view_item",
    { value: num(value), currency: currency || "RON", items: [{ item_name: itemName }] },
    "ViewContent",
    { content_name: itemName, value: num(value), currency: currency || "RON" }
  );
